<template>
	<div class="centerWidth">
		<div class="tag_position d-flex d-align-center">
			<img src="../assets/images/add1.png" alt="">
			当前位置：<a href="/">首页</a>&gt; <span>特色专区</span>
		</div>
		<div class="dynamic-wrap">
			<div class="item" v-for="(item,index) in list" :key="index" @click="toJump(item.url)">
				<img :src="item.img" alt="">
				<div>{{item.title}}</div>
			</div>
		</div>
	</div>
</template>

<script>

	import {zhuanqu} from "../api";

  export default {
		name: "About",
		data() {
			return {
        list: [],
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
      getList() {
				let ajaxData = {	}
        zhuanqu(ajaxData).then(res => {
					if (res.code == 1) {
						this.list = res.data
					}
				})
			},
      toJump(url){
        if (url) {
          window.open(url)
        }
      }
		}
	}
</script>

<style scoped lang="scss">
	.dynamic-wrap {
		background: #fff;
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		margin-top: 40px;
    margin-bottom: 40px;

		.item {
      width: 224px;
			position: relative;
			display: flex;
			flex-direction: column;
			align-items: center;
			margin-right: 20px;
			margin-bottom: 20px;
			background-color: #fff;
			transition: all .3s ease;
			box-shadow: 0 0 1.5rem rgba(9, 41, 77, 0.12);
			cursor: pointer;
      border-radius: 5px;

			&:nth-child(5n) {
				margin-right: 0;
			}

			&:hover {
				position: relative;
				z-index: 9;
				background-color: rgba(34, 87, 171, 1);
				transform: translate3d(0, -0.3rem, 0);
				box-shadow: 0 0.25rem 1.25rem rgba(62, 151, 223, 0.3);
				div{
					color:#fff;
				}
			}

			img {
        border-radius: 5px 5px 0 0 ;
				width: 224px;
				height: 150px;
				box-shadow: 0 0 0.5rem rgba(9, 41, 77, 0.12);
        object-fit: cover;
			}

			div {
				padding: 20px;
				font-size: 16px;
				color: #000;
        text-align: center;
			}
		}
	}
</style>
